import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, OnInit, AfterViewInit } from '@angular/core';
import { Globals } from '../../globals/globals';
import { DatePipe } from '@angular/common';
import { SelectOption } from '../teiasoft-select/teiasoft-select.component';
import { getDateOnlyDisplayDate } from '../../utils/date-only.utils';
declare var $: any;

@Component({
  selector: 'teiasoft-confirmable-input',
  templateUrl: './teiasoft-confirmable-input.component.html',
  styleUrls: ['./teiasoft-confirmable-input.component.scss']
})
export class TeiasoftConfirmableInputComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() type: 'select' | 'input' | 'date' | 'inputnumeric' = 'select';
  @Input() options: SelectOption[] = [];
  @Input() value: any;
  @Input() inputType: string = 'text';
  @Input() startIcon = "";
  @Input() customUndoFunction?: () => void;
  @Input() maxLength: number = 524288; // Default max Length
  @Input() roundDigits: number = 2;
  @Input() applyChange: boolean = false; // MQF-436 MODAL DISCARD CHANGE
  @Input() allowNegative: boolean = false;
  @Output() confirmChange = new EventEmitter<any>();
  @Output() onValueChanged = new EventEmitter<boolean>();
  @Output() navigationKey = new EventEmitter<KeyboardEvent>();


  dateValue: number = -1;
  originalValue: any;
  //isChangedObject: boolean = false;
  valueChanged: boolean = false;
  numberRegex?: RegExp;

  constructor(public globals: Globals, private datePipe: DatePipe) {

  }

  ngOnInit() {
    this.originalValue = this.value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["value"] && changes["value"].currentValue != undefined) {
      this.value = changes["value"].currentValue;
      /* if (!this.isValidNumberInput(this.value)){
        this.value = parseFloat(this.value).toFixed(this.roundDigits);
      } */

      this.setSelectedElement();
      /*  if (this.options && this.options.length > 0 && this.type == 'select' && JSON.stringify(changes["value"].currentValue) != JSON.stringify(changes["value"].previousValue)) {
         this.onValueChange(this.value);
       }; */
      // Parent updates represent an applied value, not an in-progress edit.
      this.originalValue = this.value;
      if (this.valueChanged) {
        this.valueChanged = false;
        this.onValueChanged.emit(this.valueChanged);
      }
    }

    if (changes && changes["options"] && changes["options"].currentValue != undefined) {
      this.options = new Array();
      this.options = changes["options"].currentValue;
      this.setSelectedElement();
    }

    if (changes && changes["roundDigits"]) {
      this.roundDigits = changes["roundDigits"].currentValue;
    }

    if (changes && changes["type"] && changes["type"].currentValue != undefined) {
      this.type = changes["type"].currentValue;
      if (!changes["type"].firstChange && changes["type"].currentValue != changes["type"].previousValue) {
        this.valueChanged = true;
        this.onValueChanged.emit(this.valueChanged);
      }
    }

    if (changes && changes["inputType"] && changes["inputType"].currentValue != undefined) {
      this.inputType = changes["inputType"].currentValue;
    }

    if (changes && changes["maxLength"]) {
      if (changes["maxLength"].currentValue != null && changes["maxLength"].currentValue != undefined)
        this.maxLength = changes["maxLength"].currentValue;
    }

    /* MQF-436 MODAL DISCARD CHANGE */
    if (changes && changes["applyChange"]) {
      this.applyChange = changes["applyChange"].currentValue;
      if (this.applyChange) this.onConfirmChangeClick();
    }
  }

  ngAfterViewInit(): void {
    //this.setSelectedElement();
  }
onValueChange(newValue: any): void {
  if (this.type === 'date') {
    this.dateValue = parseInt(newValue);
    const _date = getDateOnlyDisplayDate(this.dateValue) || new Date(this.dateValue);
    const _refDate = new Date('2000-01-01');
    if (!isNaN(_date.getTime()) && _date.getTime() > _refDate.getTime()) {
      this.value = this.datePipe.transform(_date, this.globals.dateFormat!);
    }
  } else if (this.type === 'inputnumeric') {
    newValue = newValue.replaceAll(',', '.'); // Normalize decimal separator

    // Preserve in-progress input states
    const specialCases = ["-", "-.", ".", ""];
    if (specialCases.includes(newValue) || /^-?0(\.\d*)?$/.test(newValue)) {
      this.value = newValue;
    } else if (this.isValidNumberInput(newValue, this.allowNegative)) {
      this.value = parseFloat(newValue);
    } else {
      // fallback to originalValue if invalid
      let _elem: any = document.getElementsByClassName('edp-num-input')[0]!;
      if (_elem) {
        _elem["value"] = parseFloat(this.originalValue || 0);
        this.value = _elem["value"];
      }
    }
  } else {
    this.value = newValue;
  }

  this.valueChanged = JSON.stringify(this.value) !== JSON.stringify(this.originalValue);
  this.onValueChanged.emit(this.valueChanged);
}


  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onConfirmChangeClick(); // Trigger the confirm action
    }
    if (event.key === 'Tab') {
      this.onConfirmChangeClick(); // Trigger the confirm action
    }
    if (event.key === 'Enter' || event.key === 'Tab') {
      this.navigationKey.emit(event);
    }
    if (event.key === 'Escape') {
      this.undoChange(new Event('Escape')); // Trigger the confirm action
    }
  }

  onFocusOut(): void {
    this.onConfirmChangeClick(); // Trigger the confirm action
  }

  onConfirmChangeClick() {
    // evt.preventDefault();
    // evt.stopPropagation();
    // this.valueChanged = false; // MP: REMOVED... why assuming the values hasn't changed?
    this.originalValue = this.value;
    this.onValueChanged.emit(this.valueChanged);
    if (this.type == 'date') {
      this.confirmChange.emit(this.dateValue);
    }
    else {
      if (this.value == null || (this.value != null && typeof this.value != 'object')) {
        this.confirmChange.emit(this.value);
      } else {
        let _elem = document.getElementById("tsc-select") as HTMLSelectElement;
        this.confirmChange.emit(_elem.value);
      }

    }
  }

  undoChange(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();
    if (this.customUndoFunction) {
      this.customUndoFunction();
    } else {
      this.value = this.originalValue;
      this.valueChanged = false;
      this.onValueChanged.emit(this.valueChanged);
      this.setSelectedElement();
    }
  }

  setSelectedElement() {
    if (!this.options || this.options.length == 0 || this.value == undefined) return;
    if (typeof this.value != 'object') return;
    let _foundValue: boolean = false;
    let _foundText: boolean = false;
    let _selvalue: string = "";
    for (const prop in this.value) {
      for (var x = 0; x < this.options.length; x++) {
        if (this.value[prop] == this.options[x].value) _foundValue = true;
        if (this.value[prop] == this.options[x].text) _foundText = true;
        _selvalue = this.options[x].value;
        if (_foundValue && _foundText) break;
      }
      if (_foundValue && _foundText) break;
    }
    if (_foundValue && _foundText) {
      setTimeout(() => {
        let _elem = document.getElementById("tsc-select") as HTMLSelectElement;
        _elem.value = _selvalue;
      }, 0);

    }
  }

  isModified(): boolean {
    // console.log("[QuoteTool] Valore modificato: " + (JSON.stringify(this.value) != JSON.stringify(this.originalValue) && this.valueChanged));
    return (JSON.stringify(this.value) != JSON.stringify(this.originalValue) && this.valueChanged);
  }

  isValidNumberInput(value: any, _allowNegative: boolean = false): boolean {
    let numberRegex: RegExp;
    if (_allowNegative) {
      numberRegex = new RegExp(String.raw`^-?(?:\d+|\d*\.)?(?:\d+)?$`);
    } else {
      // No negatives, but allow leading dot (".5" valid)
      numberRegex = new RegExp(String.raw`^(?:\d+|\d*\.)?(?:\d+)?$`);
    }

    return numberRegex.test(value);
  }

  getStep(): string {
    if (this.roundDigits == 0) {
      return "0";
    } else {
      let _temp: string = "1";
      for (var x = 1; x <= this.roundDigits; x++) {
        _temp = _temp + "0";
      }
      return (1 / parseInt(_temp)).toString();
    }
  }

}
